export class JobStatusDto {
	Status: number;
	PartiallyDone: boolean;

	constructor(status: number, partiallyDone: boolean) {
		this.Status = status;
		this.PartiallyDone = partiallyDone
	}
}